import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Nest16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M10.9697 6.21967C11.2626 5.92678 11.7374 5.92678 12.0303 6.21967L15.0303 9.21967C15.3232 9.51256 15.3232 9.98744 15.0303 10.2803L12.0303 13.2803C11.7374 13.5732 11.2626 13.5732 10.9697 13.2803C10.6768 12.9874 10.6768 12.5126 10.9697 12.2197L13.4393 9.75L10.9697 7.28033C10.6768 6.98744 10.6768 6.51256 10.9697 6.21967Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M1.5 3C1.91421 3 2.25 3.33579 2.25 3.75V5.75C2.25 6.61195 2.59241 7.4386 3.2019 8.0481C3.8114 8.65759 4.63805 9 5.5 9H14.5C14.9142 9 15.25 9.33579 15.25 9.75C15.25 10.1642 14.9142 10.5 14.5 10.5H5.5C4.24022 10.5 3.03204 9.99956 2.14124 9.10876C1.25045 8.21796 0.75 7.00978 0.75 5.75V3.75C0.75 3.33579 1.08579 3 1.5 3Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
